export default __webpack_public_path__ + "static/media/section0-img1.bf9eb8be.png";